import type { ReactNode } from "react";

interface BannerProps {
  tone: "info" | "success" | "warning" | "error";
  title: string;
  children?: ReactNode;
}

export function Banner({ tone, title, children }: BannerProps) {
  return (
    <div className={`banner banner-${tone}`} role={tone === "error" ? "alert" : "status"}>
      <strong>{title}</strong>
      {children !== undefined && <div>{children}</div>}
    </div>
  );
}

export function LoadingLine({ label }: { label: string }) {
  return (
    <div className="loading-line" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

export function IndeterminateProgress({ label }: { label: string }) {
  return (
    <div className="planning-progress" aria-busy="true">
      <div
        className="progress-track"
        role="progressbar"
        aria-label="Pick plan generation progress"
        aria-valuetext={label}
      >
        <span className="progress-indicator" />
      </div>
      <div className="progress-stage" role="status" aria-live="polite">
        <span className="spinner" aria-hidden="true" />
        <span>
          <span className="visually-hidden">Current stage: </span>
          {label}
        </span>
      </div>
    </div>
  );
}

export function ErrorDetails({ items }: { items: readonly string[] }) {
  if (items.length === 0) return null;
  return (
    <details className="error-details">
      <summary>View details ({items.length})</summary>
      <ol>
        {items.map((item, index) => (
          <li key={`${index}-${item}`}>{item}</li>
        ))}
      </ol>
    </details>
  );
}
